import { Injectable } from '@angular/core';
import { BFFGetInboxResponsePayload, BFFUpdateInboxMessageResponsePayload } from '@cpak/adp-cpak-bff-service-models';
import { FetcherService } from './fetcher/fetcher.service';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InAppNotificationsFetchService {
  constructor(private fetcher: FetcherService) {}

  public loadInAppNotifications(
    countryIds: string,
    territoryIds: string[]
  ): Observable<BFFGetInboxResponsePayload['data'] | null> {
    const params = this.getParams(countryIds, territoryIds);

    return this.fetcher.get<BFFGetInboxResponsePayload>('api/inAppInbox', params).pipe(
      map(res => {
        if (!res) {
          return null;
        }
        return res.data;
      })
    );
  }

  public markInAppNotificationsAsRead(
    countryIds: string,
    territoryIds: string[]
  ): Observable<BFFUpdateInboxMessageResponsePayload['data'] | null> {
    const params = this.getParams(countryIds, territoryIds);

    return this.fetcher.patch<BFFUpdateInboxMessageResponsePayload>('api/inAppInbox', params).pipe(
      map(res => {
        if (!res) {
          return null;
        }
        return res.data;
      })
    );
  }

  private getParams(countryIds: string, territoryIds: string[]): { countryIds: string[]; territoryIds?: string[] } {
    if (!!territoryIds.length) {
      return {
        countryIds: [countryIds],
        territoryIds,
      };
    }

    return {
      countryIds: [countryIds],
    };
  }
}
